import api from '../api'

const AuthModule = {
  state: {
    user: null
  },
  mutations: {
    setUser (state, payload) {
      state.user = payload
    }
  },
  actions: {
    signUserIn ({ commit }, payload) {
      commit('setLoading', true)
      commit('clearError')

      api.validateUser(payload)
        .then((response) => {
          api.socketConnect(response.data.token)
          commit('setUser', response.data)
          commit('setLoading', false)
        })
        .catch(error => {
          commit('setLoading', false)
          commit('setError', error)
        })
    }
  },
  getters: {
    user (state) {
      return state.user
    }
  }
}

export default AuthModule
